import { TwitterPicker } from 'react-color';
import { COLOR_PICKER_OPTIONS } from '../../../const/color-picker-const';
import React, { useState } from 'react';
import { Input, InputLabel } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import { DARK_UPDATED_FIELD, LIGHT_UPDATED_FIELD } from '../../../const/color-const';

const useStyles = makeStyles(theme => ({
  currentColor: props => ({
    background: props.color,
    height: '30px',
    width: '30px',
    cursor: 'pointer',
    position: 'relative',
    outline: 'none',
    borderRadius: '4px',
    margin: '6px 0 12px 0',
    border: '1px solid black',
  }),
  pickerWrapper: props => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(2),
    backgroundColor: props.isUpdated ? (theme.palette.type === 'light' ? LIGHT_UPDATED_FIELD : DARK_UPDATED_FIELD) + ' !important' : 'transparent',
  }),
  fieldWrapper: {
    width: 220,
  },
}));

const twitterStyle = {
  default: {
    input: {
      display: 'none',
    },
    hash: {
      display: 'none',
    },
  },
};

const ColorPicker = (props) => {
  const { form, field, label, setDirty } = props;
  const [pickerOpen, setPickerOpen] = useState(false);
  const componentMeta = form.getFieldMeta(field.name);
  const isUpdated = (componentMeta.initialValue !== componentMeta.value) && form.dirty;
  const classes = useStyles({ color: field.value, isUpdated: isUpdated });
  
  React.useEffect(() => {
    setDirty?.(isUpdated);
  }, [isUpdated, setDirty]);
  
  return (
    <div>
      <div id="colorPicker" className={`${classes.pickerWrapper} pickerWrapper`}>
        <FormControl disabled className={classes.fieldWrapper}>
          <InputLabel>{label}</InputLabel>
          <Input
            endAdornment={
              <InputAdornment position="start">
                <div className={classes.currentColor} onClick={() => setPickerOpen(!pickerOpen)} />
              </InputAdornment>
            }
          />
        </FormControl>
      </div>
      {pickerOpen && <TwitterPicker
        width={312}
        triangle="hide"
        color={field.value}
        styles={twitterStyle}
        onChangeComplete={
          (color) => {
            form.setFieldValue(field.name, COLOR_PICKER_OPTIONS.find(colorOption => colorOption.value.toLowerCase() === color.hex)?.name);
            setPickerOpen(false);
          }
        }
        colors={COLOR_PICKER_OPTIONS.map(color => color.value)}
      />
      }
    </div>
  );
};

ColorPicker.propTypes = {
  form: PropTypes.object,
  field: PropTypes.object,
  label: PropTypes.object,
};

export default ColorPicker;